import React, { useContext, useEffect, useState } from 'react';
import './right-panel.less'
import { ProjectContext } from '@/config/context'
import { findMonitorObjectPrimitiveByPrimitiveUuid } from '@/config/api/primitives';
import { MonitorObjectPrimitive } from '@/interface/primitive';
import { Spin, Table, message } from 'antd';
import { globalQuantity, quantity, quantityData, warningLimit } from '@/interface/quantity';
import { Transfer2DisplayScale } from '@/utils/utils';
import { queryMobjectDetail, queryQuantityGroups } from '@/config/api/mobject';
import { mobject, quantityGroup } from '@/interface/mobject';
import { queryProjectGlobalQuantities } from '@/config/api/quantity-setting';
import axios from 'axios';
import { constage } from '@/interface/constage';
import dayjs from 'dayjs';
import { queryQuantityCurrentDataList, queryQuantityData } from '@/config/api/quantity-data';
import { quantityDetailStore } from '@/store';
import LineChartBoard from '@/components/charts/line-chart-board';
import { queryQuantities } from '@/config/api/quantity';
import classnames from 'classnames';
import Column from 'antd/lib/table/Column';
import { QuantityName } from '@/components/QuantityName';
import AlertTag from '@/components/alert-tag';
import { warningGradeDict } from '@/utils/type';

interface Iprops {
    activeEntityUuid: string,
    projectId: number
}

const EntityUuid = "111";
export default function ConstructOverview(props: Iprops) {
    const projectId = useContext(ProjectContext);//当前项目id
    const [monitorPrimitives, setMonitorPrimitives] = useState<MonitorObjectPrimitive[]>([]);//储存图元绑定的监测对象信息
    const [loading, setLoading] = useState<boolean>(false)

    const [quatityList, setQuatityList] = useState<quantity[]>([])
    const [constageList, setConstageList] = useState<constage[]>([])
    const [quantityDataList, setQuantityDataList] = useState<quantityData[]>([])
    const [projectGlobalQuantityList, setProjectGlobalQuantityList] = useState<globalQuantity[]>([])

    const [activeQuantityId, setActiveQuantityId] = useState<number>(17162)


    useEffect(() => {
        if (!props.activeEntityUuid) {
            if (quatityList?.length > 0) setQuatityList([]);
            if (constageList?.length > 0) setConstageList([]);
            if (quantityDataList?.length > 0) setQuantityDataList([]);
            if (projectGlobalQuantityList?.length > 0) setProjectGlobalQuantityList([]);
            return
        }
        findMonitorObjectPrimitiveByPrimitiveUuid(projectId, props.activeEntityUuid).then(res => {
            if (res.data === null || res.data?.length === 0) {
                if (quatityList?.length > 0) setQuatityList([]);
                if (constageList?.length > 0) setConstageList([]);
                if (quantityDataList?.length > 0) setQuantityDataList([]);
                if (projectGlobalQuantityList?.length > 0) setProjectGlobalQuantityList([]);
                return
            } else if (res.status === 200) {
                let data: MonitorObjectPrimitive[] = res.data || [];
                setMonitorPrimitives(data)
                generateData(data[0].monitor_object_id)
            }
        }).catch(err => {
            message.error("获取数据失败", err);
        })
    }, [props.activeEntityUuid])

    const generateData = (mobjectId: number) => {
        setLoading(true)
        let mobjectObj: mobject;
        let projectGlobalQuantities: globalQuantity[]
        let constages: constage[]
        queryMobjectDetail(mobjectId).then(res => {
            let mobjectDetail: mobject = res.data;
            mobjectObj = mobjectDetail;

            let queryQuantityGroupsPromise = queryQuantityGroups(mobjectId, {
                project_id: props.projectId,
                mobject_id: mobjectId,
            });
            let globalQuantitiesPromise = queryProjectGlobalQuantities(props.projectId);
            return axios.all([queryQuantityGroupsPromise, globalQuantitiesPromise])
        }).then(res => {
            let quantityGroups: quantityGroup[] = res[0].data || [];
            quantityGroups = quantityGroups.sort((a, b) => b.level - a.level);
            projectGlobalQuantities = res[1].data;
            setProjectGlobalQuantityList([...projectGlobalQuantities])
            constages = [...(mobjectObj?.constages || [])];
            constages.sort((a, b) => dayjs(a.start_time).valueOf() - dayjs(b.start_time).valueOf());
            setConstageList(constages)
            return queryQuantities(props.projectId, { mobject_id: mobjectId })
        }).then(q_res => {
            let quantities: quantity[] = q_res.data || [];
            generateQuantityAndData(quantities, constages, projectGlobalQuantities)
        })
    }

    const generateQuantityAndData = (quantities: quantity[], constages: constage[], projectGlobalQuantities: globalQuantity[]) => {
        // let projectId = this.context;
        let projectId = props.projectId
        let promiseList = [];
        quantities = quantities.map(item => Object.assign({}, item));
        quantities.forEach((q: quantity) => {
            q.constages = constages;
            let gQuantity: globalQuantity = projectGlobalQuantities.find(item => item.type === q.type);
            if (gQuantity) {
                q.chinese_name = gQuantity.chinese_name;
                q.unit_type = gQuantity.unit_type;
                q.precision = gQuantity.precision;
                let scale = Transfer2DisplayScale(q.unit_type);
                q.scale = scale;
                q.valid_data = gQuantity.valid_data;
            }
            let params = {
                start_time: quantityDetailStore._startTime?.getTime() || null,
                end_time: quantityDetailStore._endTime?.getTime() || null,
                sampling_period: quantityDetailStore._samplingPeriod || null,
                data_type: quantityDetailStore._dataType || 1,
            }
            if (params.start_time == null) {
                params['limit'] = 300;
            }
            else if (params.sampling_period == null) {
                let end = params.end_time;
                if (end == null) {
                    end = new Date().getTime();
                }
                let start = params.start_time;
                // TODO: 计算降采样
                params.sampling_period = calculateDownSample(start, end);
                quantityDetailStore.setSamplingPeriod(params.sampling_period);
            }
            if (params.sampling_period === -1) {
                params.sampling_period = null;
            }
            let promise = queryQuantityData(q.id, params);
            promiseList.push(promise);
        })
        let qids = quantities.map(item => item.id);
        let queryQuantityCurrentDataPromise = queryQuantityCurrentDataList({
            project_id: projectId,
            quantity_ids: qids,
        })
        queryQuantityCurrentDataPromise.then(res => {
            let dataList = res.data || [];
            dataList.forEach(item => {
                if (!item) {
                    return;
                }
                let id = +item['id'];
                let value = +item['value'];
                let q: quantity = quantities.find(qs => qs.id === id);
                q.current_value = value * q.scale;
                if (q.valid_data != null && Math.abs(q.valid_data) < Math.abs(value)) {
                    q.current_grade = -1;
                } else if (!q.is_evaluate) {
                    q.current_grade = 0;
                } else {
                    q.current_grade = checkQuantityEvaluation(q.warning_limit, value, q.constages);
                }
            })
            console.log('after checkQuantityEvaluation', quantities)
            // this.setState({
            //     quantities: [...quantities]
            // })
            return axios.all([...promiseList]);
        }).then(res => {
            let data: quantityData[] = res.map(item => item.data).filter((item: quantityData) => !!item.id) || [];
            quantities.forEach((q: quantity, idx) => {
                let qData = data[idx];
                if (!!qData && !!qData.data) {
                    qData.data = qData.data?.map(item => {
                        item.value *= q.scale
                        return item;
                    }) || [];
                    qData.max = qData.max ? qData.max * q.scale : null;
                    qData.min = qData.min ? qData.min * q.scale : null;
                    qData.mean = qData.mean ? qData.mean * q.scale : null;
                    qData.precision = q.precision;
                    qData.unit_type = q.unit_type;
                    qData.chinese_name = q.chinese_name;
                    qData.warning_limit = q.warning_limit;
                    qData.is_evaluate = q.is_evaluate;
                    qData.scale = q.scale;
                }
                // q.quantityData = data[idx];
            })
            quantities = quantities.sort((a, b) => b.current_grade - a.current_grade);
            setQuatityList([...quantities])

            setQuantityDataList(data)
            if (data.length > 0) {
                setActiveQuantityId(data[0].id)
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    const checkQuantityEvaluation = (warningLimits: warningLimit[], value: number, constages: constage[]) => {
        let time = dayjs().valueOf();
        if (constages.length === 0) return 0;
        let stage: constage = constages.find((item: constage) => dayjs(item.start_time).valueOf() <= time && dayjs(item.end_time).valueOf() >= time);
        if (!stage) stage = constages[constages.length - 1];
        let limit = warningLimits.find((item: warningLimit) => item.stage_id === stage.id)?.values;
        if (!limit)
            return 0;
        if (Math.abs(limit['t5']) < 1e-9)
            return 0;
        if (!value)
            return 0;
        if (limit['t5'] <= Math.abs(value)) {
            return 5;
        } else if (limit['t4'] <= Math.abs(value)) {
            return 4;
        } else if (limit['t3'] <= Math.abs(value)) {
            return 3;
        } else if (limit['t2'] <= Math.abs(value)) {
            return 2;
        } else {
            return 1;
        }
    }

    const calculateDownSample = (start: number, end: number) => {
        const date1 = dayjs(start);
        const date2 = dayjs(end);
        if (date2.diff(date1, 'M') >= 2) {
            return 86400;
        }
        if (date2.diff(date1, 'M') >= 1) {
            return 43200;
        }
        if (date2.diff(date1, 'd') >= 10) {
            return 3600;
        }
        if (date2.diff(date1, 'd') >= 1) {
            return 300;
        }
        return null;
    }

    const afterDelete = () => {
        generateQuantityAndData(quatityList, constageList, projectGlobalQuantityList)
    }

    return (
        <div className="right-info-panel-container">
            <Spin spinning={loading} wrapperClassName='spin-main'>
                <div className="main">
                    {/* <div className="head">
                    {monitorPrimitives?.map((item, index) => (
                        <div key={index} className="head-item">
                            {item.monitor_object_name}
                        </div>
                    ))}
                </div> */}
                    <div className='panel-main'>
                        <div className='mobject-list'>
                            {quantityDataList?.map((item) => (
                                <div className={classnames({
                                    "item": true,
                                    "item-active": item.id == activeQuantityId
                                })}
                                    onClick={() => { setActiveQuantityId(item.id) }}
                                >
                                    <QuantityName showChineseName record={item} />
                                </div>
                            ))}
                        </div>

                        <div className='chart'>
                            {quantityDataList?.map((q: quantityData, idx) => (
                                q.data && q.id == activeQuantityId ? (
                                    <LineChartBoard
                                        q={q}
                                        chartHeight={230}
                                        headDisable={true}
                                        constages={constageList}
                                        afterDelete={() => { afterDelete() }} />
                                ) : null
                            ))}
                        </div>
                        {quatityList?.find(item => item.id == activeQuantityId) && (
                            <div className='warning-limit'>
                                <div className='item'>
                                    <div className='label'>
                                        当前数值：
                                    </div>
                                    <div className='value'>
                                        {quatityList?.find(item => item.id == activeQuantityId).current_value?.toFixed(+quatityList?.find(item => item.id == activeQuantityId).precision) || ''} {quatityList?.find(item => item.id == activeQuantityId).unit_type || ''}
                                    </div>
                                </div>
                                <div className='item'>
                                    <div className='label'>
                                        评估：
                                    </div>
                                    <div className='value'>
                                        <AlertTag current_grade={quatityList?.find(item => item.id == activeQuantityId).current_grade} />
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>

                </div>
            </Spin>
        </div>



    )
}